import { CollegeSlider, TagList } from "../components/home";
import { registerWidget, DME, DMEData, generalSettings } from "dmeditor";
import { fetchContentList } from "../components/fetchData";

export interface TrackEnitity {
  list: Array<any>;
}

export const TrackRender = (props: DME.WidgetRenderProps<TrackEnitity>) => {
  const {
    blockNode: { data },
  } = props;

  const { list } = data;

  return (
    <div className="px-6">
      <div className="flex flex-col gap-y-6">
        <TagList
          onChange={() => {}}
          tags={[
            { name: "Scholarship Update", value: "schoolship" },
            { name: "Favorite List", value: "fav-list" },
          ]}
        />
      </div>
      <div>
        <CollegeSlider list={list} />
      </div>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-track",
      icon: "matchfit",
      name: "Track",
      category: "basic",
      settings: [...generalSettings],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-track",
            data: { list: [] },
          };
        },
      },
    },
    {
      render: TrackRender,
      onServerSideLoad: serverSideLoad,
    }
  );
};

const serverSideLoad = async (blockData: any) => {
  const trackList = await fetchContentList(`query{
    block(filter:{_location_parent_id: 480}){
      id,title,image, text, html, link
    }        
  }`);
  blockData.data.list = trackList.block;
};
